export const MOBILE_DOWNLOAD_URL = {
  googlePlay:
    "https://play.google.com/store/apps/details?id=com.debank.rabbymobile",
};
